<template>
  <div class="columns is-marginless shape is-paddingless is-marginless">
    <div class="column is-paddingless is-2">
      <figure class="">
        <img :src="url" class="logo" alt="">
      </figure>
    </div>
    <div class="column is-paddingless is-6">
      <p class="p_size26 has-text-link has-text-weight-bold">
        {{dataInfoOpp.nomCommercial}}
      </p>
      <p class="p_size14 has-text-secondary-icon has-text-weight-bold">
        {{dataInfoOpp.themeCampagne}}
      </p>
      <p class="has-text-default p_size12 bottomVert">{{dateValidite}}</p>
    </div>
</div>
</template>

<script>
import { formatDate, urlPhoto } from '@/services/opportunite/formatTab';

export default {
  name: 'infoOpp',
  props: ['dataInfoOpp'],
  computed: {
    dateValidite() {
      return formatDate(this.dataInfoOpp.dateCreation);
    },
    url() {
      return urlPhoto(this.dataInfoOpp.urlLogo);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/composants/infoOpp.vue